export function Loop(loop) {
    let rows = [];
    for (let i = 0; i < loop; i++) {
      rows.push(i);
    }
    return rows;
  }